<template>
  <div class="app-checkout-ident-data">
    <div class="ident-data--header"><slot name="txtHeadline"></slot></div>
    <Ident :ident.sync='identData.identCard'
           :nationality.sync='identData.nationality'
           :ident-type.sync='identData.identType'
           process="activation"
    >
      <template v-for="slot in possibleChildSlotsFor('IdentData')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Ident>
    <Stepper
      :loading-next="loading"
      :disabledNext="loading || disableButton"
      :show-prev="true"
      :btnNextAriaLabel="getSlotText('btnNextAriaLabelIdentData')"
      @prev="$emit('goBack')"
      @next="save()"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>

import Stepper from '../../generic/Stepper.vue'
import Ident from '../identData/Ident.vue'
import validationFlow from '@/mixins/validators/validationFlow'
import { validationMixin } from 'vuelidate'
import preFilledObjectInput from '@/mixins/preFilledObjectInput'
import isValid from '@/mixins/validators/isValid'
import transaction from '@/mixins/transaction'
import trackingHandler from '@/mixins/trackingHandler'
import { omit } from 'vue-apollo/lib/utils'

export default {
  name: 'IdentData',
  data () {
    return {
      loading: false
    }
  },
  components: {
    Ident,
    Stepper
  },
  mixins: [
    isValid,
    validationMixin,
    validationFlow,
    transaction('checkout'),
    preFilledObjectInput('identData', 'getIdentData'),
    trackingHandler
  ],
  props: {
    process: {
      type: String,
      default: 'ordering'
    },
    headline: {
      type: String,
      default: 'h2'
    }
  },
  methods: {
    findAndSetFocusManually () {
      const targetStepName = this.getCurrentStepName
      const targetStepLi = document.querySelector(`li.${targetStepName}`)

      if (targetStepLi) {
        // Find the button
        const targetButton = targetStepLi.querySelector("[role='button']")

        if (targetButton) {
          targetButton.setAttribute('tabindex', '0') // make it focusable
          targetButton.focus()
        }
      }
    },
    save () {
      this.startLoader()
      this.loading = true

      this.$store.commit('checkoutv2/' + this.process + '/_identData/setIdentData', {
        nationality: this.identData.nationality,
        identCard: omit(this.identData.identCard, 'identMethods'),
        identType: this.identData.identType
      })

      this.$store
        .dispatch('checkoutv2/' + this.process + '/initiate')
        .then(() => {
          this.clearToasts()
          this.$emit('goForward')
        })
        .catch((error) => {
          this.errorToast(this.getErrorMessage(error))
          this.triggerErrorTracking(error)
          throw new Error('validateAndSavePayment failed')
        })
        .finally(() => {
          this.loading = false
          this.stopLoader(() => {
            this.findAndSetFocusManually()
          })
        })
    }
  },
  computed: {
    disableButton () {
      return !this.identData.identType || this.identData.identCard?.name === ''
    },
    getIdentData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_identData/identData']
    },
    getCurrentStepName: function () {
      return this.$store.getters['checkoutv2/' + this.process + '/step']
    }
  },
  watch: {
    disableButton (newVal) {
      this.$emit('update-disable', newVal)
    }
  }
}
</script>
